import React from "react"
import NoContent from "components/elements/NoContent"
import AlertBoxWrapper from "components/elements/AlertBox/AlertBoxWrapper"
import useModal from "services/useModal"
import { ModalName } from "sharedTypes"
import { BADGE_PRINTING_ARTICLE_URL } from "utilities/externalLinks"
import BadgeUpgradeAlert from "./BadgeUpgradeAlert"

type Props = {
  badgePrinting: boolean
}

const NoBadges = ({
  badgePrinting,
}: Props) => {
  const showModal = useModal()

  return (
    <>
      {!badgePrinting && (
        <AlertBoxWrapper absolute>
          <BadgeUpgradeAlert />
        </AlertBoxWrapper>
      )}
      <NoContent
        title="Badges"
        icon="badges"
        horizontalCTAs
        descriptionItems={["Create and print personalized, branded badges featuring multi-purpose QR codes for seamless check-in and enhanced attendee engagement."]}
        callsToActions={[{
          icon: "plus-big",
          text: "Create First Badge",
          action: () => showModal(ModalName.BadgeTemplateBrowser),
          isButton: true,
        }, {
          icon: "book",
          text: "Learn more about Diobox Badge Printing",
          link: BADGE_PRINTING_ARTICLE_URL,
        }]}
      />
    </>
  )
}

export default NoBadges
